/*
 * Emotion header controller
 *
 * @class EmotionHeader
 * @depends jquery.js, CC.js, jquery.actionController.js
 * @author Oleg Slobodskoi aka Kof
 */

var $ = require('jquery');
var features = require('diy/util/features');

module.exports = function ( _super ) {
    var d = this.d = {
            footerHeight: 17,
            toolbarHeight: 30,
            sidebarWidth: 100,
            speed: 300,
            saveTimeout: 500,
            path: {
                show: '/app/module/emotionheader/show',
                update: '/app/module/emotionheader/update',
                logo: '/app/module/emotionheader/logoupdate',
                removeLogo: '/app/module/emotionheader/removelogo',
                search: '/app/module/emotionheader/searchimages',
                autocomplete: '/app/module/emotionheader/gettags'
            },
            baseLoadViewUrl: '/app/module/emotionheader/',
            viewsDependencies: {
                'Settings': 'Background'
            },
            resizableOptions: {
                minHeight: 300,
                maxHeight: 600,
                containment: 'document',
                handles: {
                    s: '#eh-resize-handle'
                },
                start: function () {

                },
                stop: function () {

                },
                alsoResize: '#eh-editor-content'
            },
            keyVisuals: {
                hasConfirmed: false
            },
            params: {}
        },
        uploadedLogo = false,
        logoPanelOpened = false,
        imageUploaded = false,
        imageUploadPanelOpened = false;

    var self = this,
        $eh = this.$eh = $('#emotion-header'),
        $ehImg = this.$ehImg = $('#emotion-header-img', $eh), // TODO should be deleted after refactoring
        $edit = this.$edit = $('#eh-edit'),
        $ehe = this.$ehe = $('#eh-editor'),
        $eheToolbar = $('#eh-editor-toolbar', $ehe),
        $eheContent = this.$eheContent = $('#eh-editor-content', $ehe),
        $eheHelp = this.$eheHelp = $('.moduleHelpLink', $ehe),
        $close = $('#eh-close', $ehe),
        $toolbar = $('#eh-tabs', $ehe),
        opened = false,
        loading = false,
        timeout,
        prevView,
        pageId = this.pageId = $ehe.attr('data-page');
    //TODO: refactor this for save modes
    //pageName = this.pageName = $ehe.attr('data-page-name'),
    //websiteHasPageModule = this.websiteHasPageModule = ($ehe.attr('data-website-has-module') == 'true');

    this.loadedViews = {};

    this.model = null;
    //Store the ajax request for the model so we can abort it
    this._modelXhrReq = null;

    this.size = {
        height: $eh.outerHeight(),
        width: $eh.outerWidth()
    };

    this.offset = {
        top: $eh.offset.top,
        left: $eh.offset.left
    };

    this.init = function () {
        cms.common.util.EventingMixin.mixin(this);

        var timeout;

        /* exit, if template has no emotion header*/
        if ($eh.length == 0) {
            return false;
        }

        this.placeEditor();

        $eh.add($edit).multihover(function () {
            if (!opened) {
                clearTimeout(timeout);
                self.showEditButton(d.speed);
            }
            ;
        }, function () {
            if (!opened) {
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    self.hideEditButton(d.speed);
                }, 2000);
            }
            ;
        });

        // set a z-index only as big as it's needed //
        $edit.css({'z-index': diy.editor.getNewTopZIndex(undefined, undefined, '.diyw') + 1});

        $eh
            .add($ehe)
            .add($edit)
            .actionController(self, {
                events: 'click keypress addTooltip updateTooltip slide slidechange',
                history: true
            });

        $(document).bind('diy.cms.EmotionHeader.shopHasProducts', function (e, data) {
            // tell server-side that shop products situation has changed
            $.ajaxSetup({contentType: "application/x-www-form-urlencoded; charset=UTF-8"});
            $.post('/app/module/emotionheader/shopproductstoggle',
                {cstok: jimdoData.cstok});

            if (null === self.model) {
                self.loadViewClick(null, null, false);
            } else {
                if (0 == data) {
                    CC.EmotionHeader.model.set('shopHasProducts', data, false);
                } else {
                    method = "system.public.hasShoppingbasket";
                    proxy_path = (window.webserverProtocol && (window.webserverProtocol == "https://") ? window.sslServerUrl : '')
                    + '/proxy';

                    args = {
                        'mod.instance_id': data.instance_id,
                        'mod.locale': apsinth.lang,
                        'mod.externalModuleId': data.moduleId
                    };
                    mm[data.moduleId].ajaxUtil.rpcRequest(proxy_path + '/rpc/', method, args, function (data, error) {
                        CC.EmotionHeader.model.set('shopHasProducts', data ? "1" : "0", false);
                    }, this);
                }
            }
        });
        $(document).bind('CC.EmotionHeader.Preview.onHeaderHeightModified', function (e, height) {
            self.size.height = $eh.outerHeight();
            self.placeEditor();
        });


        $(document).bind('CC.EmotionHeader.Preview.onTaskStarted', function (e) {
            self.loading(true);
        });

        $(document).bind('CC.EmotionHeader.Preview.onTaskCompleted', function (e) {
            self.loading(false);
        });


        $(window).resize(function () {
            self.placeEditor();
        });

        // set up the eh edit button
        $edit.button();

        // set up the eh editor tabs
        $toolbar.tabs();
        $toolbar.bind('tabsbeforeactivate', function (event, ui) {
            var params;

            var dataEl = ui.newTab.find('a')[0];

            params = dataEl.dataset && dataEl.dataset.params ?
                dataEl.dataset.params :
                dataEl.attributes['data-params'].value;

            $(document).trigger('diy-emotionheader-sectionOpened', {
                'tabName': params.toLowerCase()
            });
            /* track opening of a header section */
            $(document).trigger('diy-editor-generic-sectionAccessed', {
                sectionCodeName: 'eh-editor.' + params.toLowerCase()
            });
        });

        $(document).bind('diy-eh-component-clicked diy-eh-component-dragstart', function (ev, data) {
            switch (data.elem.attr('id')) {
                case 'cc-eh-img-wrapper':
                    $toolbar.find('#eh-background').click();
                    break;
                case 'emotion-header-title':
                case 'emotion-header-title-bg':
                    $toolbar.find('#eh-title').click();
                    break;
                case 'emotion-header-logo':
                    $toolbar.find('#eh-logo').click();
                    break;
                case 'scButton':
                    $toolbar.find('#eh-shop').click();
                    break;
            }
        });

        // set up the save and cancel eh editor handlers
        $('#eh-save', $ehe).button().click(function () {
            if (typeof CC.EmotionHeader.loadedViews.Background !== 'undefined') {
                self._ignoreDataChange = true;
                self.model.setImageList(CC.EmotionHeader.loadedViews.Background.getImageList());
                self._ignoreDataChange = false;
            }
            self.model.trigger('eh-save');
            self.save({successCallback: self.hideEditor});
        });
        $('#eh-cancel', $ehe).button().click(function () {
            self.model.trigger('eh-cancel');
            self.cancel();
        });
    };
    this.showEditButton = function (duration) {
        if (!this.$editWrap) {
            this.$editWrap = $edit.wrap(
                $('<div></div>').css({
                    'position': 'absolute',
                    'top': '0',
                    'left': '0'
                })
            ).parent();
        }

        this.$editWrap
            .show()
            .offset($eh.offset())
            .css({
                width: $eh.innerWidth(),
                height: $eh.innerHeight()
            });

        $edit.slideDown(duration);
    };

    this.hideEditButton = function (duration) {
        $edit.slideUp(duration, function () {
            if (self.$editWrap) {
                self.$editWrap.hide();
            }
        });
    };
    this.placeEditor = function () {
        var eheWidth = $ehe.outerWidth();

        if (typeof($eh) == 'object' && $eh.offset) {
            self.offset = $eh.offset();
        }
        $ehe.css({
            top: self.size.height + self.offset.top,
            /* in case it's ie8, outerWidth - width gets us the border width on both sides */
            width: (self.size.width > eheWidth ? self.size.width : eheWidth) - ($.isBrowser.ie8 ? $ehe.outerWidth() - $ehe.width() : 0),
            left: self.offset.left + eheWidth + d.sidebarWidth > $(window).width() ? ((eheWidth - self.size.width) < self.offset.left ? self.offset.left - (eheWidth - self.size.width) : self.offset.left) : self.offset.left
        });
    };

    //TODO: refactor for save options
    /*this.getSaveMode = function() {
     var mode = $('#eh-keyvisual-mode').val();
     return mode;
     };

     this.confirmSave = function(saveFn, context, abortFn, target, forceMode) {

     var mode = forceMode || this.getSaveMode();

     // only show the confirm box if there is at least one other per page module
     // and there the save mode is different than the already used save mode
     if (!this.websiteHasPageModule || mode == this.pageSaveMode
     // || d.keyVisuals.hasConfirmed
     ) {
     saveFn.call(context);
     return;
     }

     switch (mode) {
     case 'page':
     var msg = jimdoData.messages.keyVisualsPage;
     break;
     case 'inherit':
     var msg = jimdoData.messages.keyVisualsInherit;
     break;
     case 'global':
     var msg = jimdoData.messages.keyVisualsGlobal;
     break;
     }
     // replace page name in confirm message
     msg = msg.replace('{pagename}', this.pageName);

     $(target || '#eh-keyvisual-mode').message({
     message: msg,
     status: 'confirm',
     closable: false,
     width: 360,
     mainContainer: $ehe,
     template: '<div class="eh-confirm-dialog"><p class="x-message-content">#message#</p><br/><br/>\
     <button type="button" class="x-message-button-ok x-message-action" selected="selected">'+jimdoData.messages.save+'</button>\
     <button type="button" class="x-message-button-abort x-message-action">'+jimdoData.messages.cancel+'</button>\
     </div>',
     onClose: function(e, status, ctx) {
     if (status == 'ok') {
     saveFn.call(context);
     d.keyVisuals.hasConfirmed = true;
     } else {
     if (typeof abortFn == "function") {
     abortFn.call(context);
     }
     }
     }
     });
     };*/
    this._ignoreDataChange = false;
    var dataChangeTriggerTimeout;
    this.listenDataChange = function (model, data, changed, extra) {
        var ignoreTrigger = false;
        if (extra && extra.dataChanged === false) {
            ignoreTrigger = true;
        }
        ignoreTrigger = ignoreTrigger || this._ignoreDataChange;
        if (!ignoreTrigger) {
            var self = this;
            dataChangeTriggerTimeout && clearTimeout(dataChangeTriggerTimeout);
            dataChangeTriggerTimeout = setTimeout(function () {
                self.triggerDataChanged();
            }, 500);
        }
    };
    this.dataChanged = false;
    this.triggerDataChanged = function () {
        if (this.dataChanged != true) {
            this.dataChanged = true;
            $(document.body).trigger('EHeaderTriedModifications.BSA');
        }
    };
    /**
     * this function is triggered with actionController plugin help, when an tab is clicked
     */
    this.loadViewClick = function (e, viewName, doOpenEditor) {
        // doOpenEditor is optional. true is default.
        if (typeof(doOpenEditor) == 'undefined' || doOpenEditor == null) {
            doOpenEditor = true;
        }

        if (!opened && doOpenEditor) {
            Modul.abortEditingModules();
            self.openEditor();
        }

        //Load model
        if (self.model === null) {
            self.loadModel(function() {
                self.loadViewClick(e, viewName, doOpenEditor);
            });
            return false;
        }

        //Load Preview
        if (!self._previewInitialized) {
            self._previewInitialized = true;
            $.construct('CC.EmotionHeader.Preview', diy.editor.emotionHeader.Preview, {lazy: true});
            $.construct('CC.EmotionHeader.Preview', 'create');
        }

        // if we should not open editor we don't bother with viewName
        if (!doOpenEditor) {
            return false;
        }

        // active is the default tab to open
        if (viewName == 'active') {
            //Hack to trigger actionController action
            //By default this is the first tab
            var activeTab = $toolbar.tabs('option', 'active');
            $toolbar.find('a').eq(activeTab || 0).trigger('click');
            return false;
        }

        self.switchView(viewName);
        return false;
    };

    this.reload = function() {
        this.loadModel(function() {
            self.loadViewClick(null, 'active', false);
        });
    };

    this.loadModel = function(callback) {
        self.loading(true);
        if (self._modelXhrReq !== null) {
            self._modelXhrReq.abort();
        }
        self._modelXhrReq = $.ajax({
            url: d.path.show,
            data: {pageId: self.pageId},
            method: 'GET',
            dataType: 'json',
            complete: function () {
                self.loading(false);
                self._modelXhrReq = null;
            },
            error: function () {
                //TODO: give a meaningful message
            },
            success: function (response) {
                if (response.status != 'success') {
                    //TODO: error
                } else {
                    if (self.model) {
                        self._ignoreDataChange = true;
                        self.model.loadData(response.data);
                        self._ignoreDataChange = false;
                        self.dataChanged = false;
                    } else {
                        var model = new EmotionHeaderModel();
                        model.loadData(response.data);
                        self.model = model;
                        self.model.bind('change', $.proxy(self.listenDataChange, self));
                    }

                    if (typeof callback === 'function') {
                        callback();
                    }
                }
            }
        });
    }

    /**
     * this function will load the view, switch to it and init it
     * after that will run the callback if passed
     * if view is already loaded will return false
     */
    this.loadView = function (viewName, callback, clbParams, clbScope) {
        var self = this, viewWrapper;

        if (this.loadedViews[viewName]) {
            this.switchView(viewName);
            return false;
        }

        if (d.viewsDependencies[viewName]) {
            var parentViewName = d.viewsDependencies[viewName];

            if (self.loadedViews[parentViewName]) {
                viewWrapper = this.loadedViews[parentViewName].switchSubView(viewName);
            } else {
                this.loadView(
                    parentViewName,
                    function () {
                        this.loadView(viewName, callback, clbParams, clbScope);
                    },
                    this
                );
                return;
            }
        }
        this.loading(true);

        self.loadedViews[viewName] = new diy.editor.emotionHeader[viewName](self);
        $.get(d.baseLoadViewUrl + viewName.toLowerCase(), function (data) {
            if (!viewWrapper) {
                viewWrapper = $('<div id="eh-view-wrapper-' + viewName + '"/>');
                $($eheContent[0]).append(viewWrapper);
            }
            self.switchView(viewName);
            viewWrapper.html(data);
            var view = self.loadedViews[viewName];
            view.viewWrapper = viewWrapper;
            view.init();
            if (typeof view.updateView == 'function') { // TODO remove this when all views are refactored
                view.updateView(self.model, null, self.model.getAll());
                self.model.bind('change', self.model.toHandler(view.updateView, view));
            }
            self.loading(false);
            if (callback) {
                clbScope = clbScope || self;
                clbParams = clbParams || [];
                callback.apply(clbScope, clbParams);
            }
        });
        return true;
    };

    this.switchView = function (viewName) {
        if (this.activeView !== undefined && this.activeView !== viewName) {
            self.trigger('switchView', viewName);
        }

        if (!self.loadedViews[viewName]) {
            self.loadView.call(self, viewName);
            return;
        }

        if (d.viewsDependencies[viewName]) {
            var parentView = d.viewsDependencies[viewName];
            this.switchView(parentView);
            self.loadedViews[parentView].switchSubView(viewName);
            return;
        }
        var view = self.loadedViews[viewName];

        // mark active selected view tab and mark inactive currently active tab
        $('a.active', $toolbar).removeClass('active');
        $('#' + view.tabElementId, $toolbar).addClass('active');

        // this is needed for styling
        if (!this.baseCssClass) {
            self.loading(false);
            this.baseCssClass = $ehe.attr('class');
        }
        $ehe.attr('class', view.tabElementId + ' ' + this.baseCssClass);

        // update the Help button with the new data value
        $eheHelp.attr('data', view.tabElementId);

        $('#eh-view-wrapper-' + this.activeView).hide();
        $('#eh-view-wrapper-' + viewName).show();
        this.activeView = viewName;

        var bubbleEl = $('#eh-editor .feature-guidance-help-button');
        bubbleEl.hide();

        if (typeof view.onShow === 'function') {
            view.onShow();
        }
    };

    this.hideEditor = function () {
        if (!opened) {
            return false;
        }
        opened = false;
        // scroll up to the editor
        $ehe.slideUp(d.speed, function () {
            $eh.scrollIntoView();
        });
        d.keyVisuals.hasConfirmed = false;
        $eh.removeClass('cc-eh-opened');

        if (self._modelXhrReq !== null) {
            self._modelXhrReq.abort();
        }

        this.trigger('hide', this);
        $.construct('CC.EmotionHeader.Preview', 'destroy');
        // if we let current hash, on page refresh it will automatically
        // load the last opened view, so it's set to 'eh-close' to
        // prevent browser scroll.
        jQuery(window).history('add', 'eh-close');
        return false;
    };

    this.isOpen = function () {
        return opened;
    };

    this.actionUpdateTooltip = function (e, value) {
        var $tip = $(this).data(this.id);
        $tip.html(value);
    };

    this.actionSlide = function (e, ui) {
        var self = this;
        setTimeout(function () {
            $(self).data(self.id).text(ui.tooltipValue);
        }, 20);
    };

    this.actionSlidechange = function (e, ui) {
        var self = this;
        setTimeout(function () {
            $(self).data(self.id).text(ui.tooltipValue);
        }, 20);
    };

    this.loading = function (sw) {
        loading = sw;
        $ehe[sw ? 'addClass' : 'removeClass']('eh-loading');
        return self;
    };


    this.save = function (options) {
        if (self.model === null) {
            return false;
        }

        if (self.model.isDirty()) {
            var settings = self.model.getAll();

            //  check if a logo exists  &&
            if (settings.logoDeleted == 0 &&
                    // if it was just uploaded or just set visible  &&
                (self.model.getDirtyStatus('logoDeleted') || self.model.getDirtyStatus('logoVisible')) &&
                    // the logo is visible
                settings.logoVisible == 1) {
                /**
                 * Make some SiteCatalyst tracking
                 */
                $(document).trigger('diy-editor-makeWebsiteFit', {
                    'condition': 'Applied',
                    'name': 'Logo'
                });
            }

            $.ajaxSetup({
                contentType: "application/x-www-form-urlencoded; charset=UTF-8"
            });
            self.loading(true);
            $.post(d.path.update + '?pageId=' + self.pageId, settings, function (data) {
                self.loading(false);
                if (typeof data.status != 'undefined') {
                    var scope = options.scope || self;
                    if (data.status == 'ok' && options.successCallback) {
                        features.disableFeature('EHInPristineCondition');
                        if (self.uploadedLogo == true) {
                            $(document.body).trigger('LogoSaved.BSA');
                        }
                        if (self.imageUploaded == true) {
                            $(document.body).trigger('EHeaderUploadedOwnImageSaved.BSA');
                        }
                        if (self.dataChanged) {
                            $(document.body).trigger('EHeaderModificationsSaved.BSA');
                        }
                        self.model.commitChanged();
                        options.successCallback.apply(scope, arguments);
                    }
                    if (data.status == 'error' && options.errorCallback) {
                        options.errorCallback.apply(scope, arguments);
                    }
                    self._ignoreDataChange = true;
                    self.model.loadData(data.model_data.data);
                    self._ignoreDataChange = false;
                    self.dataChanged = false;
                    if (self.model.getBackgroundVisible()) {
                        diy.module.emotionHeader.slideShow.start(data.model_data.data.slides);
                    }
                }
                self.trigger('collapse', self, [data.status]);
            }, 'json');
        } else {
            // TODO user didn't make any change so maybe we should warn it about that
            // for now, just call the successCallback
            var scope = options.scope || self;
            if (options.successCallback) {
                options.successCallback.apply(scope, []);
            }
            self.trigger('collapse', self, ['ok']);
        }
    };

    this.cancel = function () {
        if (self.model !== null) {
            //force cancel of logo data
            self.model.cancelChanged({action: 'cancel', dataChanged: false});
        }
        this.hideEditor();
        self.trigger('collapse', self);
        diy.module.emotionHeader.slideShow.start()
    };

    this.openEditor = function () {
        if (opened) {
            return false;
        }

        this.uploadedLogo = false;
        this.logoPanelOpened = false;
        this.imageUploaded = false;
        this.imageUploadPanelOpened = false;
        this.dataChanged = false;

        diy.module.emotionHeader.slideShow.stop();

        if (window.diy.core.namespace('diy.editor.siteadmin.switchbox').isActive) {
            $('#container').message({
                top: self.offset.top + (self.size.height - 80 ) / 2,
                left: self.offset.left + (self.size.width - 300 ) / 2,
                width: 300,
                status: 'alert',
                message: $ehe.attr('data-switch-mode')
            });
            return false;
        }
        ;

        /* track that the eh item has been clicked */
        $(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: 'eh-editor'
        });

        $(document.body).trigger('EHeaderOpened.BSA');
        $(document.body).trigger('diy-editor-EH-opened');

        opened = true;
        this.hideEditButton(0);
        $eh.addClass('cc-eh-opened');

        $ehe.slideDown(d.speed, function () {
            var bubbleEl = $('#eh-editor .feature-guidance-help-button');
            bubbleEl.hide();
            if ($toolbar.tabs('option', 'active') === 0 && self.activeView) {
                $(document).trigger('eh-background-show');
                if (this.model.get('backgroundVisible') == 1) {
                    bubbleEl.attr('data', 'header').show();
                }
            }
            $ehe.scrollIntoView();
        }.bind(this));

        /* trigger Eventing-Mixin */
        if (self.activeView) {
            if (self.trigger instanceof Function) {
                self.trigger('onload', self);
            }
        }
        if (self.activeView == 'Logo') {
            $(document.body).trigger('LogoPanelOpened.BSA');
            self.logoPanelOpened = true;
        }
        this.trigger('open', this);

        return true;
    };

    // TODO copy-pasted from picturemanipulation.js
    // encapsulate this in a custom control
    this.initSlider = function (params, optionControlMapper, model, invertValue) {
        invertValue = invertValue === true; // default is false
        var getInverted = function (val) {
            return invertValue ? params.min + (params.max - val) : val;
        }
        $(params.id).diy_slider({
            min: params.min,
            max: params.max,
            step: params.step,
            tipText: params.formatter,
            slide: function (e, ui) {
                optionControlMapper[params.option].valueChanged(getInverted(ui.value), true);
                if (typeof params.onSlide === 'function') {
                    params.onSlide.call($(params.id), getInverted(ui.value));
                }
            },
            stop: function (e, ui) {
                optionControlMapper[params.option].valueChanged(getInverted(ui.value), false);
            }
        });
        optionControlMapper[params.option] = {
            getValue: function () {
                var val = getInverted($(params.id).diy_slider('value'));
                /* call the mapper, if defined */
                val = typeof params.getMapper === 'function' ? params.getMapper(val) : val;
                return val;
            },
            setValue: function (val) {
                var sliderVal = typeof params.setMapper === 'function' ? params.setMapper(val) : val;
                $(params.id).diy_slider('value', getInverted(sliderVal));
            },
            valueChanged: function (sliderVal, isChanging) {
                /* call the mapper, if defined */
                var val = typeof params.getMapper === 'function' ? params.getMapper(sliderVal) : sliderVal;
                // with 5th param we force to notify the event, because
                // otherwise those views that listens only when
                // isChanging == false will not be notified
                model.set(params.option, val, true, {isChanging: isChanging}, true);
            }
        };
    };

    var isVisible = function (imgEl) {
        return imgEl && imgEl.length && imgEl.is(':visible')
            && imgEl.css('visibility') !== 'hidden'
            && imgEl.parent().css('visibility') !== 'hidden';
    };

    /**
     * Returns background image element only if it is visible.
     */
    this.getBackgroundImageEl = function () {
        var imgEl = null;
        if (!this.model) {
            // first check if the emotion header exists and has images //
            if (
                !this.$eh || !this.$eh.length || !this.$eh.attr('data-imagescount') || parseInt(this.$eh.attr('data-imagescount'), 10) === 0
            ) {
                return null;
            }

            if (isVisible(jQuery('#emotion-header-img'))) {
                imgEl = jQuery('#emotion-header-img');
            }
        } else {
            if (this.model.getBackgroundVisible()) {
                var bgSource = this.model.getBackgroundSourceType();

                if (!(bgSource == 'ImageUpload' && this.model.getUploadedImageId() == -1)) {
                    imgEl = jQuery('#cc-eh-img-preview');
                    if (!isVisible(imgEl)) {
                        imgEl = jQuery('#emotion-header-img');
                    }
                }
            }
        }
        return (imgEl && imgEl.length > 0) ? imgEl : null;
    };

    /**
     * Returns logo image element only if it is visible.
     */
    this.getLogoImageEl = function () {
        var imgEl = jQuery('#emotion-header-logo');
        if (isVisible(imgEl)) {
            return imgEl;
        }

        return null;
    };

    /**
     * Returns title bg element only if it is visible. otherwise null
     */
    this.getTitleBgEl = function () {
        var titleBgEl = jQuery('#emotion-header-title-bg');
        if (isVisible(titleBgEl)) {
            return titleBgEl;
        }

        return null;
    };

    var EmotionHeaderModel = cms.common.data.Model.extend({
        controllerUrl: '/app/module/emotionheader/',
        bgImageSourceOpts: {
            Gallery: ['imageId', 'imageVersion'], //Keyvisual
            External: ['uploadedImageId', 'externalImageId'], //GFXBOOST
            Patterns: ['patternId', 'patternBw', 'bgColor'],
            ImageUpload: ['uploadedImageId']
        },
        bgImageDefaultSettings: {
            backgroundEdited: 0,
            backgroundVertPos: 50,
            backgroundHorPos: 50,
            backgroundZoom: 100,
            brightness: 0,
            sharpen: 0,
            rotate: 0,
            backgroundAltTag: ''
        },
        getBgImageSettings: function () {
            var ret = {};
            for (var x in this.bgImageDefaultSettings) {
                ret[x] = this.get(x);
            }
            return ret;
        },
        // overriding default getter, this property should be always dynamic
        getBgImageUrl: function () {
            var
                type = this.getBackgroundSourceType(),
                loadParams = ['backgroundSourceType=' + type, 'pageId=' + self.pageId],
                params = this.bgImageSourceOpts[type];
            for (var i = 0; i < params.length; i++) {
                loadParams.push(params[i] + '=' + encodeURIComponent(this.get(params[i])));
            }
            return this.controllerUrl + 'getbgimage?' + loadParams.join('&');
        },
        setBgImageSource: function (type, loadOpts) {
            var ao = this.bgImageSourceOpts;

            var selectedId = ao[type];
            //if type not defined -> do nothing; not a valid call
            if (!selectedId) {
                return null;
            }

            var data = $.extend({},
                this.getBgResetValuesForSource(type),
                this.bgImageDefaultSettings,  // reset sliders
                loadOpts
            );

            if (type != 'ImageUpload' || loadOpts['uploadedImageId'] == -1) {
                data.backgroundAnimated = 0;
            }

            this.set(data);
            this.setBgImageUrl(this.getBgImageUrl());

        },
        getBgResetValuesForSource: function (sourceType) {
            var resetData = {
                backgroundSourceType: sourceType
            };

            //reset to default values all other sources data
            for (var type in this.bgImageSourceOpts) {
                //skip current source type
                if (!type || (type == sourceType) || !this.bgImageSourceOpts.hasOwnProperty(type)) {
                    continue;
                }

                var field;
                for (var i = 0; i < this.bgImageSourceOpts[type].length; i++) {
                    field = this.bgImageSourceOpts[type][i];
                    resetData[field] = 0;
                }
            }

            return resetData;
        },
        resetBgImage: function () {
            self.model.setBgImageSource('ImageUpload', {
                uploadedImageId: -1,
                bgColor: self.model.getBgColor()
            });
            self.model.setBgImageUrl(cc_.blankImageUrl);
        },
        setSaveMode: function (val) {
            if (val == 'default_header') {
                this.set($.extend({}, this.getDefaultHeaderParams()));
                // force changing image url
                this.setBgImageUrl(this.getBgImageUrl());
            }

            //arguments is an array like object (not an actual array), we cannot call concat directly on it
            //we use Array.prototype.slice.call to transform it to array
            this._set.apply(this, $.merge(['saveMode'], arguments));
        },
        setHeight: function (value, markChanged, extra, forceNotify) {
            //call the actual set
            this._set.apply(this, $.merge(['height'], arguments));

            //and then when value has finished changing - aka slider stop
            //get to refreshing the logo zoom value
            if (extra && extra.isChanging === false) {
                //logoZoom update
                var $logoElement = self.getLogoImageEl();
                if ($logoElement !== null) {
                    var currentHeight = this.getLogoBorderVisible() ? $logoElement.outerHeight() : $logoElement.height()
                    var newLogoZoom = Math.min(Math.round(currentHeight * 100 / value), 100);
                    var currentLogoZoom = parseInt(this.getLogoZoom(), 10);

                    //if we have a new value set it
                    //if we're @100% then we need to force notify so that the preview updates/rescales
                    if (newLogoZoom != currentLogoZoom || newLogoZoom == 100) {
                        this.setLogoZoom(newLogoZoom, true, null, true);
                    }
                }

                //titleBackgroundHeight percentage update
                var $titleBgElement = self.getTitleBgEl();
                if ($titleBgElement !== null) {
                    var currentHeight = $titleBgElement.height(),
                        newTitleBgHeightPercentage = Math.min(Math.round(currentHeight * 100 / value), 100),
                        currentTitleBgHeightPercentage = parseInt(this.getTitleBackgroundHeight(), 10);


                    //if we have a new value set it
                    //if we're @100% then we need to force notify so that the preview updates/rescales
                    if (newTitleBgHeightPercentage != currentTitleBgHeightPercentage || newTitleBgHeightPercentage == 100) {
                        this.setTitleBackgroundHeight(newTitleBgHeightPercentage, true, null, true);
                    }
                }

            }
        },
        getBgImageData: function () {
            var data = {},
                field;
            for (var i = 0; i < this.bgImageProperties.length; i++) {
                field = this.bgImageProperties[i];
                data[field] = this.get(field);
            }

            return data;
        },
        isBgProperty: function (propName) {
            return $.inArray(propName, this.bgImageProperties) >= 0;
        },
        bgImageProperties: [
            'backgroundAltTag', 'backgroundAnimated', 'backgroundEdited', 'backgroundHorPos', 'backgroundSourceType',
            'backgroundVertPos', 'backgroundZoom', 'bgColor', 'brightness', 'contrast', 'externalImageId',
            'flipHorizontal', 'flipVertical', 'imageId', 'imageVersion', 'patternBw', 'patternId', 'previewSrc',
            'randomKey', 'rotate', 'sharpen', 'uploadedImageId', 'zoomHeight',
            'zoomLeft', 'zoomTop', 'zoomWidth',
            'sourceThumbSrc', 'previewSrc', 'thumbSrc'
        ]
    });
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/emotion-header/CC.EmotionHeader.js
 ** module id = 871
 ** module chunks = 0
 **/